let pdfMakePromise

// Share one engine/font load across every PDF action, including simultaneous ones.
// Clear a failed load so another attempt can retry without retaining a rejection.
export function loadPdfMake() {
    if (!pdfMakePromise) {
        pdfMakePromise = Promise.all([
            import(/* webpackChunkName: "pdfmake" */ 'pdfmake/build/pdfmake'),
            import(/* webpackChunkName: "pdf-fonts" */ 'pdfmake/build/vfs_fonts'),
        ]).then(([engine, fonts]) => {
            const pdfMake = engine.default || engine
            const fontData = fonts.default || fonts
            pdfMake.vfs = fontData.pdfMake?.vfs || fontData.vfs || fontData
            return pdfMake
        }).catch(error => {
            pdfMakePromise = undefined
            throw error
        })
    }
    return pdfMakePromise
}
